import moment from 'moment';
import { RestaurantType } from 'models/brand.model';

const parseTime = (timeString: string): number => {
  let [hours, minutes] = timeString.split(':').map(Number);
  if (hours === 0) {
    hours = 23;
    if (minutes === 0) {
      minutes = 59;
    }
  } else {
    hours -= 1;
  }
  return hours * 60 + minutes;
};

export const isBrandOpenNow = (restaurant: RestaurantType): boolean => {
  const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  if (!restaurant.brand_working_hours) return false;

  const todayName = DAYS[moment().day()];
  const yesterdayName = DAYS[moment().subtract(1, 'day').day()];

  const todayHours = restaurant.brand_working_hours.find(
    (h) => h.name.toLowerCase() === todayName.toLowerCase()
  );
  const yesterdayHours = restaurant.brand_working_hours.find(
    (h) => h.name.toLowerCase() === yesterdayName.toLowerCase()
  );

  const currentTime = parseTime(moment().format('HH:mm'));

  // Case 1: Yesterday crosses midnight (e.g., 21:00 - 02:00)
  if (
    yesterdayHours &&
    yesterdayHours.active &&
    parseTime(yesterdayHours.opening_time) > parseTime(yesterdayHours.closing_time) &&
    currentTime < parseTime(yesterdayHours.closing_time)
  ) {
    return true;
  }

  if (todayHours) {
    // Case 2: Today crosses midnight (e.g., 21:00 - 02:00)
    if (
      todayHours.active &&
      parseTime(todayHours.opening_time) > parseTime(todayHours.closing_time)
    ) {
      return currentTime >= parseTime(todayHours.opening_time);
    }

    // Case 3: Normal time (e.g., 08:00 - 17:00)
    if (todayHours.active) {
      return (
        currentTime >= parseTime(todayHours.opening_time) &&
        currentTime < parseTime(todayHours.closing_time)
      );
    }
  }

  return false;
};

export const calculateReactivationTime = (time: string | null) => {
  if (!time) return 0;
  const currentTime = new Date().getTime() / 1000;
  const reactivationTime = time ? new Date(time).getTime() / 1000 : 0;
  const returnVal = Math.max(0, reactivationTime - currentTime);
  return Math.ceil(returnVal);
};
